import { styled } from "styled-components";

export const Card = styled.div`
  border: 1px solid #e1e4e8;
  border-radius: 6px;
  padding: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: max-content;
`;
